import { Button, Divider, Grid, Typography } from '@mui/material';
import {
  Datagrid,
  EditButton,
  List,
  TextField,
  useListContext,
  TopToolbar,
  ExportButton,
  FilterButton,
  CreateButton
} from "react-admin";
import MainLayout from '../layout/MainLayout';
import { subMerchantFilters } from './SubMerchantFilter';
import OtherHousesIcon from '@mui/icons-material/OtherHouses';
import { NameField } from './components/NameField';
import { submerchantDfs } from '../../ultis/function';
import { StatusField } from './components/StatusField';
import { useState } from 'react';
import { useEffect } from 'react'
import Color from '../layout/color/Color';
import FontSize from '../layout/FontSize';

const saveButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: '1px solid',
  fontWeight: '500',
  textAlign: 'center',
  padding: '4px 8px',
  color: Color.Button,
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '4px 8px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};

function getWindowDimensions() {
  const { innerWidth: width } = window;
  return {
    width
  };
}
export const SubMerchantList = (props) => {
  const [currentScreen, setCurrentScreen] = useState(getWindowDimensions());
  const [currentScreenPx, setCurrentScreenPx] = useState('');

  useEffect(() => {
    function handleResize() {
      setCurrentScreen(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setCurrentScreenPx((currentScreen.width - 70) + 'px')
  }, [currentScreen])

  const SubMerchantTable = (props) => {
    const { data, isLoading } = useListContext();
    if (isLoading) return null;
    const idRoot = parseInt(localStorage.getItem('submerchantID'));
    const dataTree = submerchantDfs(data, idRoot);

    return (
      <Datagrid
        bulkActionButtons={false}
        data={dataTree}
        sx={{
          '& .RaDatagrid-tableWrapper': {
            xs: {
              overflowX: 'scroll',
              width: currentScreenPx,
              overflowY: 'hidden',
              mx: '20px',
              whiteSpace: 'nowrap'
            },
            md: {
              overflowX: 'scroll',
              width: currentScreenPx,
              overflowY: 'hidden',
              mx: '20px',
              whiteSpace: 'nowrap'
            },
            lg: {
              overflowX: 'scroll',
              width: '100%',
              overflowY: 'hidden',
              whiteSpace: 'nowrap'
            },
            xl: {
              overflowX: 'scroll',
              width: '100%',
              overflowY: 'hidden',
              whiteSpace: 'nowrap'
            }
          }
        }}
      >
        <NameField source="name" />
        <TextField source="email" />
        <TextField source="address" />
        <TextField source="bank_account" />
        <StatusField source="status" />
        <EditButton />
      </Datagrid>
    )
  }
  return (
    <MainLayout>
      <Grid sx={{ textAlign: 'left' }}>
        <Button endIcon={<OtherHousesIcon sx={{color: Color.Main}} />} sx={{ textAlign: 'left', ml: 1, cursor: 'default' }} size="medium">
          <Typography variant="h3">
            SubMerchant Management
          </Typography>
        </Button>
      </Grid>
      <Divider sx={{ width: '100%', mb: 2 }} />
      <List
        {...props}
        filters={subMerchantFilters}
        actions={<SubMerchantListActions />}
        sort={{ field: 'submerchantID', order: 'ASC' }}
      >
        <SubMerchantTable {...props} />
      </List>
    </MainLayout>
  )
}

const SubMerchantListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton label="Create New" sx={saveButton}/>
      <ExportButton sx={backButton}/>
    </TopToolbar>
  );
};
